export interface Class {
    id: string;
    label: string;
    parentClassId: string | null;
    rootClassId: string;
    iconColor: string;
    order: number;
    workspaceId: string;
    source: ClassSource;
    sourceId: string | null;
}

export enum ClassSource {
    MANUAL = "manual",
    QUICKBOOKS = "quickbooks",
    RAMP = "ramp",
    GUSTO = "gusto",
}

export enum ClassFilterType {
    ANY_SELECTED = "any_selected",
    ALL_SELECTED = "all_selected",
    EXCLUDE_SELECTED = "exclude_selected",
    NO_CLASSES = "no_classes",
    HAS_CLASSES = "has_classes",
}
